import { render, staticRenderFns } from "./CreatorPartnershipIcon.vue?vue&type=template&id=534e7253&scoped=true"
import script from "./CreatorPartnershipIcon.vue?vue&type=script&lang=js"
export * from "./CreatorPartnershipIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534e7253",
  null
  
)

export default component.exports